<template>
  <v-app>
    <v-main>
      <template v-if="application">
        <map-wrapper v-if="!configureError" />
        <v-img v-else-if="params('draft') === 'true'">
          <v-container class="px-5">
            <v-col class="text-center px-5 mb-5">
              <v-alert
                :value="true"
                type="warning"
                outlined
              >
                <h3>{{ configureError }}</h3>
              </v-alert>
            </v-col>
          </v-container>
        </v-img>
      </template>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MapWrapper from './components/MapWrapper.vue'

export default {
  name: 'App',
  components: {
    MapWrapper
  },
  data: () => ({}),
  computed: {
    ...mapState(['application']),
    ...mapGetters(['config']),
    configureError () {
      if (!this.config.datasets || !this.config.datasets.length) return 'Veuillez sélectionner au moins une source de données'
      if (this.config.colors.type !== 'none') {
        const options = this.config.colors.rangeOptions || this.config.colors.enumOptions
        if (!options.dataset) return 'Veuillez sélectionner la source de données pour déterminer les couleurs'
        if (!options.field) return 'Veuillez sélectionner le champ pour déterminer les couleurs'
      }
      return null
    }
  },
  mounted () {
    this.$store.dispatch('init')
    if (this.params('draft') === 'true') this.setDatasets()
  },
  methods: {
    params (p) {
      const params = new URLSearchParams(window.location.search)
      return params.get(p)
    },
    setDatasets () {
      const datasetsLayers = this.config.infos.map(l => l.dataset.id).sort()
      const datasetsConfig = this.config.datasets.map(d => d.id).sort()
      if (datasetsLayers.toString() === datasetsConfig.toString()) return
      if (window.parent) window.parent.postMessage({ type: 'set-config', content: { field: 'datasets', value: this.config.infos.map(l => l.dataset) } }, '*')
    }
  }
}
</script>

<style>
.v-application {
  font-family: "Nunito", sans-serif!important;
}
</style>
